import Logo from "./logo";
import { LogoutRounded } from "@mui/icons-material";
import {
  AppBar,
  Avatar,
  Box,
  Container,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../store/user-store";
import { brand } from "../theme/theme";

export default function Navbar() {
  const navigate = useNavigate();
  const { user, clearUser } = useUserStore();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  const handleLogout = () => {
    setAnchor(null);
    clearUser();
    navigate("/login");
  };

  const initial = (user?.name ?? "?").trim().charAt(0).toUpperCase();

  return (
    <AppBar
      position="sticky"
      color="default"
      sx={{
        background: brand.gradient,
        color: "#fff",
        borderBottom: "none",
        boxShadow: "0 10px 30px -14px rgba(97,87,224,0.7)",
      }}
    >
      <Container maxWidth="lg" disableGutters sx={{ px: { xs: 2, sm: 3 } }}>
        <Toolbar disableGutters sx={{ minHeight: 64, gap: 2 }}>
          <Box
            onClick={() => navigate("/painel")}
            sx={{ display: "flex", alignItems: "center", gap: 1.25, cursor: "pointer", mr: 1 }}
          >
            <Logo size={36} />
            <Typography variant="h6" sx={{ fontSize: "1.1rem" }}>
              Aprende+
            </Typography>
          </Box>

          <Box sx={{ flex: 1 }} />

          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box sx={{ display: { xs: "none", sm: "block" }, textAlign: "right", lineHeight: 1.2 }}>
              <Typography variant="body2" fontWeight={600}>
                {user?.name}
              </Typography>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                {user?.access === "ADMIN" ? "Administrador" : "Utilizador"}
              </Typography>
            </Box>
            <Tooltip title="Conta">
              <IconButton onClick={(e) => setAnchor(e.currentTarget)} sx={{ p: 0.5 }}>
                <Avatar sx={{ width: 36, height: 36, bgcolor: "#fff", color: "primary.main", fontSize: 15, fontWeight: 700 }}>
                  {initial}
                </Avatar>
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchor}
              open={Boolean(anchor)}
              onClose={() => setAnchor(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              slotProps={{ paper: { sx: { mt: 1, minWidth: 180, borderRadius: 3 } } }}
            >
              <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
                <ListItemIcon sx={{ color: "inherit" }}>
                  <LogoutRounded fontSize="small" />
                </ListItemIcon>
                Sair
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
